import { render, staticRenderFns } from "./FieldDetail.vue?vue&type=template&id=51b6c83b"
import script from "./FieldDetail.vue?vue&type=script&lang=ts"
export * from "./FieldDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports